module.exports = __webpack_public_path__ + "img/search_menu.ccfba352.svg";